import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend,
} from 'recharts';
import { TrendingUp } from 'lucide-react';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Tenant geneli son N çeyrekte tamamlanan ders, geçilen quiz, üretilen
 * sertifika sayısı. Group bar — çeyrekler arası farkı görselleştirir.
 */
export default function QuarterlyTrendChart({ quarters = 4, className = '' }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const r = await fetch(`${API_URL}/api/auditor/quarterly-trends?quarters=${quarters}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('auth_token')}` },
        });
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        const body = await r.json();
        if (!cancelled) setData(body);
      } catch {
        if (!cancelled) toast.error('Çeyreklik trend yüklenemedi');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => { cancelled = true; };
  }, [quarters]);

  if (loading) {
    return (
      <Card className={className}>
        <CardContent className="p-8 text-center text-muted-foreground text-sm">Yükleniyor...</CardContent>
      </Card>
    );
  }

  if (!data) return null;

  const series = (data.series || []).map(s => ({
    label: s.label,
    Dersler: s.lessons_completed,
    Quizler: s.quizzes_passed,
    Sertifikalar: s.certificates_issued,
  }));

  return (
    <Card className={className} data-testid="quarterly-trend-chart">
      <CardHeader className="pb-3">
        <CardTitle className="text-sm flex items-center gap-2">
          <TrendingUp className="w-4 h-4" />
          Çeyreklik Trend
          <Badge variant="outline" className="ml-2 text-[10px]">son {quarters} çeyrek</Badge>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-[260px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={series} margin={{ left: 0, right: 8, top: 4, bottom: 4 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
              <XAxis dataKey="label" stroke="hsl(var(--muted-foreground))" fontSize={11} />
              <YAxis stroke="hsl(var(--muted-foreground))" fontSize={11} allowDecimals={false} width={36} />
              <Tooltip
                contentStyle={{
                  background: 'hsl(var(--background))',
                  border: '1px solid hsl(var(--border))',
                  borderRadius: 8,
                  fontSize: 12,
                }}
              />
              <Legend wrapperStyle={{ fontSize: 11 }} />
              <Bar dataKey="Dersler" fill="hsl(var(--primary))" radius={[4, 4, 0, 0]} />
              <Bar dataKey="Quizler" fill="#f59e0b" radius={[4, 4, 0, 0]} />
              <Bar dataKey="Sertifikalar" fill="#10b981" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
}
